import Environment from "./environment.type";

export const environment: Environment = {
    tenantSlug: 'hermisch',
    sentryEnvironment: 'production',
};
